<template src="./businessRegister.pug" lang="pug"> </template>
<style src="./businessRegister.scss" lang="scss" scoped> </style>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import { mapState } from 'vuex'
import router from '@/router'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        password: '',
        confirmPassword: '',
        email: '',
        firstName: '',
        lastName: ''
    }),
    validations: {
        email: {
            required,
            email
        },
        firstName: {
            required
        },
        lastName: {
            required
        },
        password: {
            required,
            minLength: minLength(6)
        },
        confirmPassword: {
            required,
            equal: function() {
                return this.password == this.confirmPassword
            }
        }
    },
    computed: {
        ...mapState({
            referralCode: (state) => state.businessRegister.referralCode,
            refStatus: (state) => state.businessRegister.refStatus
        })
    },
    mounted: function() {
        if (this.refStatus === 'registered') {
            setTimeout(_ => {
                router.push('/login')
            }, 2000)
        }
    },
    methods: {
        async register() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                await this.$store.dispatch('businessRegister/registerBussiness', {
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                    referralCode: this.referralCode,
                    subject: this.$vuetify.t('$vuetify.pages.BusinessRegister.emailSubject'),
                    text: this.$vuetify.t('$vuetify.pages.BusinessRegister.registerText')
                })
                this.reset()
            }
        },
        reset() {
            this.firstName = ''
            this.lastName = ''
            this.password = ''
            this.confirmPassword = ''
            this.email = ''
        }
    }
}
</script>
